export default {
  methods: {
    /**
     * Function that is evoked when searching through list of items.
     * @param {array} filteredItems - The array of items that have been filtered.
     */
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
